module.exports = __webpack_public_path__ + "media/slider/Banner-6-IND-7dc34843.jpg";